export const locale = {
  lang: 'ta',
  data: {
    // Menu groups
    CORE: 'முக்கிய',
    MARKETING: 'சந்தைப்படுத்தல்',
    REWARDS: 'வெகுமதிகள்',
    COMMUNICATION: 'தொடர்பு',
    SYSTEM: 'அமைப்பு',
    DATAINSIGHT: 'தரவு நுண்ணறிவு',
    ANALYTICS: 'பகுப்பாய்வு',
    REWARDSDELIVERY: 'வெகுமதிகள் & விநியோகம்',
    HELPCENTER: 'Help Center',
    HELPCENTERSECTIONS: 'Sections',
    HELPCENTERDOCUMENT: 'Help document',
    HELPDELIVERYREWARDBALANCE: 'Delivery Reward Balance',

    // Menu
    DASHBOARD: 'டாஷ்போர்டு',
    APPS: 'பயன்பாடுகள்',
    APPSMEMBER: 'உறுப்பினர்',
    APPSGROUPS: 'குழுக்கள்',
    AUCTION: 'ஏலம்',
    EVENT: 'நிகழ்வு',
    REPORTS: 'அறிக்கைகள்',
    REPORTSMEMBER: 'உறுப்பினர்',
    SPECIALDATES: 'சிறப்பு தேதிகள்',
    INCOMEEXPENSE: 'வருமானம்/செலவு',
    FAMILY: 'குடும்பம்',
    REPORTSLEDGER: 'பேரேடு',
    RECORDS: 'பதிவுகள்',
    BAPTISM: 'ஞானஸ்நானம்',
    CONFIRMATION: 'உறுதிப்படுத்தல்',
    WEDDING: 'திருமணம்',
    BURIAL: 'அடக்கம்',
    MASTER: 'குரு',
    MASTERLEDGER: 'பேரேடு',
    // Dashboard
    STATISTICS: 'புள்ளிவிவரங்கள்',
    SUBSCRIPTION: 'சந்தா',
    ALL: 'அனைத்து',
    LASTENTRIES: 'கடைசி 5 பதிவுகள்',
    VERSEOFTHEDAY: 'அன்றைய வசனம்!',
    MEMBERS: 'உறுப்பினர்கள்',
    RECEIPT: 'ரசீது',
    PAYMENT: 'பணம் செலுத்துதல்',
    SUBSCRIPTIONRECEIVED: 'சந்தா பெறப்பட்டது',
    PAID: 'செலுத்தப்பட்டது',
    YETTOPAY: 'இன்னும் செலுத்த வேண்டும்',
    RECEIPTPAYMENT: 'ரசீது மற்றும் பணம் செலுத்துதல்',
    PRIMARY: 'முதன்மை',
    SECONDARY: 'இரண்டாம் நிலை',
    NONCOMMUNICANT: 'தொடர்பற்றவர்கள்',

    //LOGIN
    ENTERMOBILE: 'மொபைல் எண்ணை உள்ளிடவும்',
    ENTERPASSWORD: 'கடவுச்சொல்லை உள்ளிடவும்',
    ENTEROTP: 'OTP ஐ உள்ளிடவும்',
    REMEMBERME: 'என்னை நினைவில் வையுங்கள்',
    FORGOTPASSWORD: 'உங்கள் கடவுச்சொல்லை மறந்து விட்டீர்களா?',
    LOGIN: 'உள்நுழைய',
    PASSWORDS: 'கடவுச்சொல்',

    // Member-List
    SHOW: 'காட்டு',
    ADD: 'சேர்க்கவும்',
    PREVIEW: 'முன்னோட்ட',
    VIEW: 'காண்க',
    STAFF: 'பணியாளர்கள்',
    AREA: 'பகுதி:',
    BIRTHDATE: 'பிறந்த தேதி',
    ANNIVERSARY: 'ஆண்டுவிழா:',
    MARITALSTATUS: 'திருமண நிலை',
    MARKASPRIMARY: 'முதன்மையாகக் குறிக்கவும்',
    MARKASSECONDARY: 'இரண்டாம் நிலை எனக் குறிக்கவும்',
    MARKASNONCOMMUNICANT: 'தொடர்பற்றவர் எனக் குறிக்கவும்',
    MARKASDECEASED: 'இறந்ததாகக் குறிக்கவும்',
    HEADER: 'உறுப்பினர் பட்டியல்',
    EXPORTASEXCEL: 'எக்செல் ஆக ஏற்றுமதி செய்யவும்',
    TOASTMESSAGEFORDELETE: 'உறுப்பினர் வெற்றிகரமாக நீக்கப்பட்டார்!',
    TOASTMESSAGEHEAD: 'வெற்றி!',
    MEMBER: 'உறுப்பினர்',
    MOBILE: 'கைபேசி',
    EMAIL: 'மின்னஞ்சல்',
    TYPE: 'வகை',
    SEARCH: 'தேடு...',
    // Member-View
    MEMBERSINCE: 'உறுப்பினர் முதல்',
    AREAGROUP: 'குழு பகுதி',
    ANNIVERSARYDATE: 'ஆண்டுவிழா தேதி',
    BAPTISMDATE: 'ஞானஸ்நானம் தேதி',
    CONFIRMATIONDATE: 'உறுதிப்படுத்தல் தேதி',
    ALERTMESSAGE: 'நடப்பு மாதத்திற்கான சந்தா தொகையை இன்னும் செலுத்தவில்லை.',
    MONTH: '/ மாதம்',
    REGULAR: 'வழக்கமான',
    IRREGULAR: 'ஒழுங்கற்ற',
    EMAILWORK: 'மின்னஞ்சல் (வேலை)',
    PHONEHOME: 'தொலைபேசி (வீடு)',
    PHONEWORK: 'தொலைபேசி (வேலை)',
    INCOMETYPE: 'வருமான வகை',
    PROFESSION: 'தொழில்',
    MONTHLYINCOME: 'மாத வருமானம்',
    DECLAREDSUBSCRIPTIONS: 'அறிவிக்கப்பட்ட சந்தா',
    COMMUNIONPARTICIPANT: 'ஒற்றுமை பங்கேற்பாளர்',
    EDIT: 'தொகு',
    ALERT: 'எச்சரிக்கை',
    TOTALRECEIPTS: 'மொத்த ரசீதுகள்',
    TOTALPAYMENTS: 'மொத்த கொடுப்பனவுகள்',
    DECLAREDSUBSCRIPTION: 'அறிவிக்கப்பட்ட சந்தா',
    FAMILYDETAILS: 'குடும்ப விவரங்கள்',
    MEMBERVIEWHEADER: 'உறுப்பினர் சுயவிவரம்',
    RECEIPTNO: 'ரசீது எண்',
    RECEIPTTYPE: 'ரசீது வகை',
    RECEIVEDDATE: 'பெற்ற தேதி',
    AMOUNT: 'தொகை',
    PAYMENTNO: 'கட்டண எண்',
    PAYMENTTYPE: 'கட்டணம் வகை',
    EXPORTASPDF: 'PDF ஆக ஏற்றுமதி செய்யவும்',
    // Member-Edit
    MEMBERINFORMATION: 'உறுப்பினர் தகவல்',
    SUBSCRIPTIONMEMBERID: 'சந்தா/உறுப்பினர் ஐடி',
    MEMBERSHIPTYPE: 'உறுப்பினர் வகை',
    MEMBERGROUPS: 'உறுப்பினர் குழுக்கள்',
    ISHEADOFFAMILY: 'குடும்பத் தலைவர்',
    FAMILYHEAD: 'குடும்பத் தலைவர்',
    RELATIONTOFAMILYHEAD: 'குடும்பத் தலைவருடனான உறவு',
    ISSUBSCRIPTIONPAYER: 'சந்தா செலுத்துபவர்',
    PERSONALINFORMATION: 'தனிப்பட்ட தகவல்',
    TITLE: 'தலைப்பு',
    FIRSTNAME: 'முதல் பெயர்',
    INVALIDFIRSTNAME: 'தவறான முதல் பெயர்',
    LASTNAME: 'கடைசி பெயர்',
    INVALIDLASTNAME: 'தவறான கடைசி பெயர்',
    GENDER: 'பாலினம்',
    INVALIDPROFESSION: 'தவறான தொழில்',
    CONTACTINFORMATION: 'தொடர்பு தகவல்',
    INVALIDCHURCHDETAILS: 'தவறான மற்ற சந்தா செலுத்திய தேவாலய விவரங்கள்',
    EMAILPERSONAL: 'மின்னஞ்சல் (தனிப்பட்ட)',
    ADDRESS: 'முகவரி',
    COUNTRY: 'நாடு',
    STATE: 'மாநிலம்',
    CITY: 'நகரம்',
    ZIPCODE: 'அஞ்சல் குறியீடு',
    ROLESPERMISSION: 'பாத்திரங்கள் & அனுமதி',
    ROLE: 'பாத்திரம்',
    DESIGNATION: 'பதவி',
    SIGNATUREURL: 'கையொப்ப URL',
    PERMISSIONS: 'அனுமதிகள்',
    SELFDECLARATION: 'சுய பிரகடனம்',
    SUBSCRIPTIONTYPE: 'சந்தா வகை',
    DECLAREDMONTHLYSUBSCRIPTION: 'அறிவிக்கப்பட்ட மாதாந்திர சந்தா',
    REGULARCOMMUNIONPARTICIPANT: 'வழக்கமான ஒற்றுமை பங்கேற்பாளர்',
    VOTINGRIGHTSINANYOTHERCHURCH: 'வேறு எந்த தேவாலயத்திலும் வாக்களிக்கும் உரிமைகள்',
    SUBSCRIBEDTOANYOTHERCHURCH: 'வேறு எந்த தேவாலயத்திற்கும் சந்தாதாரர்',
    OTHERSUBSCRIBEDCHURCHDETAILS: 'மற்ற தேவாலய சந்தாதாரர் விவரங்கள்',
    SAVECHANGES: 'மாற்றங்களை சேமியுங்கள்',
    SUBSCRIPTIONMEMBERIDISREQUIRED: 'சந்தா/உறுப்பினர் ஐடி தேவை',
    MEMBERSHIPTYPEISREQUIRED: 'உறுப்பினர் வகை தேவை',
    TITLEISREQUIRED: 'தலைப்பு தேவை',
    FIRSTNAMEISREQUIRED: 'முதல் பெயர் தேவை',
    LASTNAMEISREQUIRED: 'கடைசி பெயர் தேவை',
    BIRTHDATEISREQUIRED: 'பிறந்த தேதி தேவை',
    MARITALSTATUSISREQUIRED: 'திருமண நிலை தேவை',
    GENDERISREQUIRED: 'பாலினம் தேவை',
    MOBILEISREQUIRED: 'கைபேசி எண் தேவை',
    ADDRESSISREQUIRED: 'முகவரி தேவை',
    ZIPCODEISREQUIRED: 'அஞ்சல் குறியீடு எண் தேவை',
    AREAGROUPISREQUIRED: 'குழு பகுதி தேவை',
    DESIGNATIONISREQUIRED: 'பதவி தேவை',
    INCOMETYPEISREQUIRED: 'வருமான வகை தேவை',
    PROFESSIONIISREQUIRED: 'தொழில் தேவை',
    MONTHLYINCOMEISREQUIRED: 'மாத வருமானம் தேவை',
    MONTHLYINCOMESHOULDNOTBE0: 'மாத வருமானம் 0 ஆக இருக்கக்கூடாது',
    SUBSCRIPTIONTYPEISREQUIRED: 'சந்தா வகை தேவை',
    DECLAREDMONTHLYSUBSCRIPTIONISREQUIRED: 'அறிவிக்கப்பட்ட மாதாந்திர சந்தா தேவை',
    DECLAREDMONTHLYSUBSCRIPTIONSHOULDNOTBE0: 'அறிவிக்கப்பட்ட மாதாந்திர சந்தா 0 ஆக இருக்கக்கூடாது',
    OTHERSUBSCRIBEDCHURCHDETAILSISREQUIRED: 'மற்ற தேவாலய சந்தாதாரர் விவரங்கள் தேவை',
    UPDATEHEADER: 'உறுப்பினர் புதுப்பிக்கவும்',
    ADDHEADER: 'உறுப்பினரைச் சேர்க்கவும்',
    TOASTMESSAGEFORCREATE: 'உறுப்பினர் வெற்றிகரமாக உருவாக்கப்பட்டது!',
    TOASTMESSAGEFORUPDATE: 'உறுப்பினர் வெற்றிகரமாக புதுப்பிக்கப்பட்டார்!',
    GOBACK: 'பின்னால் செல்',
    NOTIFICATIONPREFERENCE: 'அறிவிப்பு விருப்பம்',
    NOTIFICATIONPREFERENCEISREQUIRED: 'அறிவிப்பு விருப்பம் தேவை',
    // Transaction-List
    CANCELLED: 'ரத்து செய்யப்பட்டது',
    TRANSACTIONLIST: 'பரிவர்த்தனை பட்டியல்',
    DOWNLOAD: 'பதிவிறக்க',
    DOWNLOADALLRECEIPTS: 'அனைத்து ரசீதுகளையும் பதிவிறக்கவும்',
    TOASTMESSAGE: 'பரிவர்த்தனை வெற்றிகரமாக நீக்கப்பட்டது!',
    INVOICE: 'விவரப்பட்டியல்',
    TRANSACTIONTYPE: 'பரிவர்த்தனை வகை',
    ACCOUNT: 'கணக்கு',
    CANCELIT: 'ஆம், அதை ரத்து செய்!',
    // Transaction-Preview
    TRANSACTION: 'பரிவர்த்தனை',
    FOR: 'ஆக',
    RECEIVEDBY: 'இவர் மூலம் பெற்றார்',
    TRANSACTIONPREVIEWACCOUNT: 'கணக்கு',
    LEDGERTYPE: 'லெட்ஜர் வகை',
    MONTHFOR: 'மாதம்',
    NOTES: 'குறிப்புகள்',
    THANKYOUFORYOURCONTRIBUTION: 'உங்கள் பங்களிப்புக்கு நன்றி.',
    DOWNLOADRECEIPT: 'ரசீதைப் பதிவிறக்கவும்',
    TRANSACTIONPREVIEWHEADER: 'பரிவர்த்தனை முன்னோட்டம்',
    RECEIVEDFROM: 'பெறப்பட்டது',
    PAIDBY: 'செலுத்தப்பட்டது',
    GENERATERECEIPT: 'ரசீதை உருவாக்கவும்',
    REGENERATERECEIPT: 'ரசீதை மீண்டும் உருவாக்கவும்',
    BACKTOLIST: 'மீண்டும் பட்டியலில்',
    TRANSACTIONPREVIEWTOASTMESSAGE: 'ரசீது வெற்றிகரமாக உருவாக்கப்பட்டது!',
    RECEIPTSENTSUCCESSFULLY: 'ரசீது வெற்றிகரமாக அனுப்பப்பட்டது!',
    // Transaction-Edit
    ADDITIONALNOTES: 'கூடுதல் குறிப்புகள்',
    TXNID: 'Txn ஐடி, கட்டண ஐடி போன்றவை',
    TRANSACTIONDATE: 'பரிவர்த்தனை தேதி',
    INVALIDRECEIVEDBY: 'பெறப்பட்டது தவறானது',
    INVALIDNOTES: 'செல்லாத குறிப்புகள்',
    TRANSACTIONDATEISREQUIRED: 'பரிவர்த்தனை தேதி தேவை',
    LEDGERISREQUIRED: 'லெட்ஜர் தேவை',
    AMOUNTISREQUIRED: 'தொகை தேவைப்படுகிறது',
    AMOUNTSHOULDNOTBENEGATIVEORZERO: 'தொகை எதிர்மறையாகவோ அல்லது பூஜ்ஜியமாகவோ இருக்கக்கூடாது',
    SAVE: 'சேமிக்கவும்',
    CANCELTRANSACTION: 'பரிவர்த்தனையை ரத்துசெய்',
    SAVEANDADDNEW: 'சேமி & புதியதைச் சேர்க்கவும்',
    ACCOUNTS: 'கணக்கு',
    ACCOUNTISREQUIRED: 'கணக்கு தேவை',
    PAYMENTTYPEISREQUIRED: 'கட்டண வகை தேவை',
    PAYMENTNOTE: 'கட்டணக் குறிப்பு',
    OTHERINFO: 'மற்ற தகவல்',
    UPDATEHEADERS: 'பரிவர்த்தனையைப் புதுப்பிக்கவும்',
    ADDHEADERS: 'பரிவர்த்தனையைச் சேர்க்கவும்',
    TOASTMESSAGEFORUPDATES: 'பரிவர்த்தனை வெற்றிகரமாக புதுப்பிக்கப்பட்டது!',
    TOASTMESSAGEFORADD: 'பரிவர்த்தனை வெற்றிகரமாக சேர்க்கப்பட்டது!',
    TOASTMESSAGEFORCANCELLED: 'பரிவர்த்தனை வெற்றிகரமாக ரத்து செய்யப்பட்டது!',
    WANTTOSENDNOTIFICATION: 'ரசீதை அறிவிப்பாக அனுப்ப விரும்புகிறீர்களா?',
    YESSENDIT: 'ஆம், அனுப்புங்கள்!',
    // Groups
    GROUPS: 'குழுக்கள்',
    // Group-List
    NOMEMBERSFOUND: 'உறுப்பினர்கள் இல்லை',
    SEARCHMEMBER: 'உறுப்பினர் தேடல்',
    SORTAZ: 'A - Z வரிசைப்படுத்து',
    SORTZA: 'Z - A வரிசைப்படுத்து',
    // Group-Sidebar
    ALLMEMBERS: 'அனைத்து உறுப்பினர்கள்',
    AREAGROUPS: 'குழுக்கள் பகுதி',
    ADDNEWAREAGROUP: 'புதிய பகுதி குழுவைச் சேர்க்கவும்',
    AREAGROUPNAME: 'குழு பகுதி பெயர்',
    ADDNEWMEMBERGROUP: 'புதிய உறுப்பினர் குழுவைச் சேர்க்கவும்',
    MEMBERGROUPNAME: 'உறுப்பினர் குழுவின் பெயர்',
    OTHERINFOMG: 'மற்ற தகவல்',
    AREAGROUPRS: 'குழு பகுதி',
    MEMBERGROUP: 'குழு உறுப்பினர்',
    UPDATE: 'புதுப்பிக்கவும்',
    CLOSE: 'மூடு',
    // Auction
    NOHARVESTEVENTSAREAVAILABLE: 'அறுவடை நிகழ்வுகள் எதுவும் கிடைக்கவில்லை, சேர்க்கவும் பொத்தானைக் கிளிக் செய்வதன் மூலம் ஒன்றை உருவாக்கவும்',
    DELETE: 'அழி',
    AUCTIONITEMS: 'ஏல பொருட்கள்',
    TOTALAMOUNT: 'மொத்த தொகை',
    BALANCE: 'இருப்பு',
    VIEWAUCTIONITEMS: 'ஏலப் பொருட்களைப் பார்க்கவும்',
    AUCTIONHEADER: 'அறுவடை நிகழ்வுகள்',
    AUCTIONTOASTMESSAGE: 'அறுவடை நிகழ்வு வெற்றிகரமாக நீக்கப்பட்டது!',
    AREYOUSURE: 'நீங்கள் சொல்வது உறுதியா?',
    DELETEIT: 'ஆம், அதை நீக்கு!',
    // Auction-Item
    PAY: 'செலுத்து',
    AUCTIONITEMHEADER: 'ஏல பொருட்கள்',
    AUCTIONITEMTOASTMESSAGE: 'ஏலப் பொருள் வெற்றிகரமாக நீக்கப்பட்டது!',
    DESCRIPTION: 'விளக்கம்',
    STATUS: 'நிலை',
    NAME: 'பெயர்',
    AUCTIONITEMBALANCE: 'மீதி இருப்பு',
    ACTIONS: 'செயல்கள்',
    AUCTIONITEMTYPE: 'வகை',
    // Auction-Amount-Sidebar
    BALANCES: 'மீதி இருப்பு:',
    ADDAUCTIONITEMAMOUNT: 'ஏலப் பொருளின் தொகையைச் சேர்க்கவும்',
    AMOUNTSHOULDNOTBEZEROORNEGATIVE: 'தொகை பூஜ்ஜியமாகவோ அல்லது எதிர்மறையாகவோ இருக்கக்கூடாது',
    CANCEL: 'ரத்து செய்',
    NEWAUCTIONAMOUNTSIDEBARTOASTMESSAGE: 'ஏலப் பொருளின் தொகை வெற்றிகரமாகச் சேர்க்கப்பட்டது!',
    AUCTIONMEMBER: 'உறுப்பினர்',
    MEMBERISREQUIRED: 'உறுப்பினர் தேவை',
    AUCTIONDESCRIPTION: 'விளக்கம்',
    DESCRIPTIONISREQUIRED: 'விளக்கம் தேவை',
    ISFULLAMOUNTPAID: 'முழுத் தொகையும் செலுத்தப்பட்டதா?',
    TOTALAMOUNTISREQUIRED: 'மொத்த தொகை தேவை',
    TOTALAMOUNTSHOULDNOTBEZEROORNEGATIVE: 'மொத்த தொகை பூஜ்ஜியமாகவோ அல்லது எதிர்மறையாகவோ இருக்கக்கூடாது',
    AUCTIONBALANCE: 'இருப்பு',
    BALANCEISREQUIRED: 'இருப்பு தேவை',
    BALANCESHOULDNOTBEZEROORNEGATIVE: 'இருப்பு பூஜ்ஜியமாகவோ அல்லது எதிர்மறையாகவோ இருக்கக்கூடாது',
    ADDAUCTIONITEM: 'ஏலப் பொருளைச் சேர்க்கவும்',
    UPDATEAUCTIONITEM: 'ஏலப் பொருளைப் புதுப்பிக்கவும்',
    AUCTIONITEMSTOASTMESSAGE: 'ஏலப் பொருள் வெற்றிகரமாக சேர்க்கப்பட்டது!',
    DATE: 'தேதி',
    AUCTIONDATEISREQUIRED: 'ஏல தேதி தேவை',
    ADDAUCTIONDETAILS: 'ஏல விவரங்களைச் சேர்க்கவும்',
    UPDATEAUCTIONDETAILS: 'ஏல விவரங்களைப் புதுப்பிக்கவும்',
    TOASTMESSAGEFORADDAUCTION: 'அறுவடை நிகழ்வு விவரங்கள் வெற்றிகரமாக சேர்க்கப்பட்டது!',
    TOASTMESSAGEFORUPDATEAUCTION: 'அறுவடை நிகழ்வு விவரங்கள் வெற்றிகரமாக புதுப்பிக்கப்பட்டன!',
    // Event
    ADDEVENT: 'நிகழ்வைச் சேர்க்கவும்',
    EVENTTOASTMESSAGE: 'நிகழ்வு வெற்றிகரமாக புதுப்பிக்கப்பட்டது!',
    // Event-Sidebar
    EVENTDESCRIPTION: 'விளக்கம்',
    EVENTTYPE: 'நிகழ்வு வகை',
    EVENTTYPEISREQUIRED: 'நிகழ்வு வகை தேவை',
    STARTDATETIME: 'தொடக்க தேதி நேரம்',
    STARTDATETIMEISREQUIRED: 'தொடக்க தேதி நேரம் தேவை',
    ENDDATETIME: 'முடிவு தேதி நேரம்',
    ENDDATETIMEISREQUIRED: 'முடிவு தேதி நேரம் தேவை',
    FACILITYTYPE: 'வசதி வகை',
    FACILITYTYPEISREQUIRED: 'வசதி வகை தேவை',
    CHURCHFACILITY: 'தேவாலய வசதி',
    CHURCHFACILITYISREQUIRED: 'தேவாலய வசதி தேவை',
    MEMBERRESIDENCE: 'உறுப்பினர் குடியிருப்பு',
    SELECTMEMBERGROUP: 'உறுப்பினர் குழுவைத் தேர்ந்தெடுக்கவும்',
    SELECTAREAGROUP: 'பகுதி குழுவைத் தேர்ந்தெடுக்கவும்',
    SELECTEVENTTYPE: 'நிகழ்வு வகையைத் தேர்ந்தெடுக்கவும்',
    SELECTCHURCHFACILITY: 'தேவாலய வசதியைத் தேர்ந்தெடுக்கவும்',
    MEMBERRESIDENCEISREQUIRED: 'உறுப்பினர் குடியிருப்பு தேவை',
    OTHERPLACENAME: 'பிற இடப் பெயர்',
    OTHERPLACENAMEISREQUIRED: 'வேறு இடத்தின் பெயர் தேவை',
    SENDTO: 'அனுப்புங்கள்',
    SENDTOISREQUIRED: 'கட்டாயம் அனுப்ப வேண்டும்',
    ISPRIVATEEVENT: 'தனிப்பட்ட நிகழ்வு',
    UPDATEEVENT: 'நிகழ்வைச் புதுப்பிக்கவும்',
    TOASTMESSAGEFORADDEVENT: 'நிகழ்வு வெற்றிகரமாக சேர்க்கப்பட்டது!',
    TOASTMESSAGEFORUPDATEEVENT: 'நிகழ்வு வெற்றிகரமாக புதுப்பிக்கப்பட்டது!',
    TOASTMESSAGEFORDELETEEVENT: 'நிகழ்வு வெற்றிகரமாக நீக்கப்பட்டது!',
    // Reports-Member
    RMAREAGROUP: 'குழு பகுதி:',
    EMAILRM: 'மின்னஞ்சல்:',
    RMHEADER: 'உறுப்பினர் - அறிக்கை',
    EXPORTASDOCX: 'Docx ஆக ஏற்றுமதி செய்யவும்',
    // Reports-Member-Sidebar
    DATEOFBIRTHAGE: 'பிறந்த தேதி/வயது',
    HEADOFFAMILY: 'குடும்பத் தலைவர்',
    SUBSCRIPTIONPAYER: 'சந்தா செலுத்துபவர்',
    APPLYFILTERS: 'வடிப்பான்களைப் பயன்படுத்து',
    NONE: 'இல்லை',
    BEFOREDATE: 'தேதிக்கு முன்',
    AFTERDATE: 'தேதிக்குப் பிறகு',
    AGERANGE: 'வயது வரம்பு',
    DECEASED: 'இறந்த உறுப்பினர்',
    YES: 'ஆம்',
    NO: 'இல்லை',
    MALE: 'ஆண்',
    FEMALE: 'பெண்',
    SINGLE: 'திருமணம் ஆகவில்லை',
    MARRIED: 'திருமணமானவர்',
    WIDOWED: 'விதவை',
    DIVORCED: 'விவாகரத்து பெற்ற நபர்',
    SEPARATED: 'பிரிக்கப்பட்ட நபர்',
    // Reports-Transaction-Report
    AMOUNTRANGE: 'தொகை வரம்பு',
    FORMONTH: 'மாதத்திற்கு',
    TRANSACTIONREPORT: 'பரிவர்த்தனை - அறிக்கை',
    // Special-Dates
    BIRTHDAY: 'பிறந்த நாள்',
    WEDDINGANNIVERSARY: 'திருமண ஆண்டு விழா',
    SPECIALDATESHEADER: 'சிறப்பு தேதிகள்',
    // Income-Expense
    MULTIACCOUNTVIEW: 'பல கணக்கு பார்வை',
    TOTALRECEIPT: 'மொத்த ரசீது',
    TOTALPAYMENT: 'மொத்த கட்டணம்',
    CATEGORY: 'வகை',
    CATEGORYCONDENSED: 'வகை',
    DATEDETAILED: 'தேதி',
    CATEGORYDETAILED: 'வகை',
    INCOMEEXPENSEHEADER: 'வருமான செலவு அறிக்கை',
    COMBINED: 'இணைந்தது',
    CONDENSED: 'ஒடுக்கப்பட்டது',
    DETAILED: 'விரிவான',
    NOINCOME: 'வருமானம் மற்றும் செலவு இல்லை இடையே',
    // Family
    PLEASESELECTAFAMILYHEAD: 'குடும்பத் தலைவரைத் தேர்ந்தெடுக்கவும்',
    FAMILYAREAGROUP: 'குழு பகுதி',
    TOTALSUBSCRIPTION: 'மொத்த சந்தா',
    RECEIPTSPAYMENTS: 'ரசீதுகள்/கட்டணங்கள்',
    FAMILYHEADER: 'குடும்ப அறிக்கைகள்',
    FAMILYCATEGORY: 'வகை',
    SEARCHHEAD: 'குடும்பத் தலைவரைத் தேர்ந்தெடுக்கவும்',
    // Ledger
    PLEASESELECTALEDGERTYPE: 'லெட்ஜர் வகையைத் தேர்ந்தெடுக்கவும்',
    MEMBERDETAILED: 'உறுப்பினர்',
    LEDGERREPORTS: 'பேரேடு அறிக்கைகள்',
    SELECTLEDGER: 'லெட்ஜரைத் தேர்ந்தெடுக்கவும்',
    // Baptism
    BAPTISMTOASTMESSAGE: 'ஞானஸ்நானம் பற்றிய விவரங்கள் வெற்றிகரமாக நீக்கப்பட்டன!',
    BAPTISEDDATE: 'ஞானஸ்நானம் பெற்ற தேதி',
    BAPTISMGENDER: 'பாலினம்',
    PARENTSNAME: 'பெற்றோர் பெயர்',
    // Baptism-Sidebar
    NAMEISREQUIRED: 'பெயர் தேவை',
    INVALIDADDRESS: 'தவறான முகவரி',
    INVALIDGODPARENTS: 'தவறான கடவுள் பெற்றோர் பெயர்கள்',
    BAPTISMDATEISREQUIRED: 'ஞானஸ்நானம் எடுக்கும் தேதி தேவை',
    AREPARENTSCHURCHMEMBER: 'பெற்றோர் சர்ச் உறுப்பினர்களா?',
    PARENTSFAMILYHEAD: 'பெற்றோர் (குடும்பத் தலைவர்)',
    CHURCHMEMBERIDISREQUIRED: 'தேவாலய உறுப்பினர் ஐடி தேவை',
    PARENTSNAMEISREQUIRED: 'பெற்றோர் பெயர் தேவை',
    PARENTSPROFESSION: 'பெற்றோர் தொழில்',
    PARENTSPROFESSIONISREQUIRED: 'பெற்றோர் தொழில் தேவை',
    GODPARENTS: 'கடவுள் பெற்றோர்',
    GODPARENTSNAMEISREQUIRED: 'கடவுளின் பெற்றோர் பெயர்கள் தேவை',
    ADDBAPTISMDETAILS: 'ஞானஸ்நானம் பற்றிய விவரங்களைச் சேர்க்கவும்',
    UPDATEBAPTISMDETAILS: 'ஞானஸ்நானம் பற்றிய விவரங்களைப் புதுப்பிக்கவும்',
    BAPTISMTOASTMESSAGEFORADD: 'ஞானஸ்நானம் பற்றிய விவரங்கள் & உறுப்பினர் சேர்க்கப்பட்டது!',
    BAPTISMTOASTMESSAGEFORUPDATE: 'ஞானஸ்நானம் பற்றிய விவரங்கள் வெற்றிகரமாக புதுப்பிக்கப்பட்டன!',
    // Confirmation
    APPLICANTS: 'விண்ணப்பதாரர்கள்',
    STARTDATE: 'தொடக்க தேதி',
    ENDDATE: 'முடிவு தேதி',
    VIEWCONFIRMATIONAPPLICANTS: 'உறுதிப்படுத்தல் விண்ணப்பதாரர்களைக் காண்க',
    CONFIRMATIONDESCRIPTION: 'விளக்கம்',
    CONFIRMATIONSTARTDATE: 'தொடக்க தேதி',
    CONFIRMATIONENDDATE: 'முடிவு தேதி',
    NOCONFIRMATIONBATCHESMSG: 'உறுதிப்படுத்தல் தொகுதிகள் இல்லை. சேர்க்கவும் பொத்தானைக் கிளிக் செய்வதன் மூலம் ஒன்றை உருவாக்கவும்.',
    UPDATECONFIRMATIONBATCH: 'உறுதிப்படுத்தல் தொகுப்பைப் புதுப்பிக்கவும்',
    ADDCONFIRMATIONBATCH: 'உறுதிப்படுத்தல் தொகுப்பைச் சேர்க்கவும்',
    CONFIRMATIONBATCH: 'உறுதிப்படுத்தல் தொகுதி',
    // Confirmation-Batch
    CONFIRMATIONBATCHGENDER: 'பாலினம் :',
    CONFIRMATIONBATCHADDRESS: 'முகவரி:',
    CONFIRMATIONBATCHCITY: 'நகரம்:',
    NATIVECHURCH: 'பூர்வீக தேவாலயம்:',
    CONFIRMATIONAPPLICANTS: 'உறுதிப்படுத்தல் விண்ணப்பதாரர்கள்',
    BACK: 'பின்னால் செல்',
    CONFIRMATIONBATCHTOASTMESSAGE: 'உறுதிப்படுத்தல் விண்ணப்பதாரர் வெற்றிகரமாக நீக்கப்பட்டார்!',
    TOASTHEAD: 'வெற்றி!',
    PLACEOFBIRTH: 'பிறந்த இடம்',
    PLACEOFBAPTISM: 'ஞானஸ்நானம் செய்யும் இடம்',
    // Confirmation-Applicant-Add
    APPLICANTDETAILS: 'விண்ணப்பதாரர் விவரங்கள்',
    PLACEOFBIRTHS: 'பிறந்த இடம்',
    PLACEOFBIRTHISREQUIRED: 'பிறந்த இடம் தேவை',
    PLACEOFBAPTISMISREQUIRED: 'ஞானஸ்நானம் எடுக்கும் இடம் தேவை',
    NATIVECHURCHS: 'பூர்வீக தேவாலயம்',
    NATIVECHURCHISREQUIRED: 'பூர்வீக தேவாலயம் தேவை',
    ISTHEAPPLICANTCHURCHMEMBER: 'விண்ணப்பதாரர் சர்ச் உறுப்பினரா?',
    APPLICANTMEMBERID: 'விண்ணப்பதாரர் உறுப்பினர் ஐடி',
    SELECTTHEAPPLICANTMEMBERID: 'விண்ணப்பதாரர் உறுப்பினர் ஐடியைத் தேர்ந்தெடுக்கவும்',
    SELECTAPPLICANTMEMBERID: 'விண்ணப்பதாரர் உறுப்பினர் ஐடியைத் தேர்ந்தெடுக்கவும்',
    PARENTDETAILS: 'பெற்றோர் விவரங்கள்',
    FATHERSNAME: 'தந்தையின் பெயர்',
    FATHERSNAMEISREQUIRED: 'தந்தை பெயர் தேவை',
    MOTHERSNAME: 'தாய் பெயர்',
    MOTHERSNAMEISREQUIRED: 'தாயின் பெயர் தேவை',
    AREPARENRTSCHURCHMEMBER: 'பெற்றோர் சர்ச் உறுப்பினர்களா?',
    FATHERMEMBERID: 'தந்தை உறுப்பினர் ஐடி',
    SELECTTHEFATHERMEMBERID: 'தந்தை உறுப்பினர் ஐடியைத் தேர்ந்தெடுக்கவும்',
    SELECTFATHERMEMBERID: 'தந்தை உறுப்பினர் ஐடியைத் தேர்ந்தெடுக்கவும்',
    MOTHERMEMBERID: 'தாய் உறுப்பினர் ஐடி',
    SELECTTHEMOTHERMEMBERID: 'தாய் உறுப்பினர் ஐடியைத் தேர்ந்தெடுக்கவும்',
    SELECTMOTHERMEMBERID: 'தாய் உறுப்பினர் ஐடியைத் தேர்ந்தெடுக்கவும்',
    ADDHEADERED: 'உறுதிப்படுத்தல் விண்ணப்பதாரரைச் சேர்க்கவும்',
    UPDATEHEADERED: 'உறுதிப்படுத்தல் விண்ணப்பதாரரைப் புதுப்பிக்கவும்',
    TOASTMESSAGEFORCREATES: 'உறுதிப்படுத்தல் விண்ணப்பதாரர் வெற்றிகரமாக உருவாக்கப்பட்டது!',
    TOASTMESSAGEFORUPDATED: 'உறுதிப்படுத்தல் விண்ணப்பதாரர் வெற்றிகரமாக புதுப்பிக்கப்பட்டார்!',
    // Wedding-Edit
    WEDDINGINFORMATION: 'திருமண தகவல்',
    WEDDINGDATE: 'திருமண தேதி',
    WEDDINGDATEISREQUIRED: 'திருமண தேதி தேவை',
    WEDDINGPLACE: 'திருமண இடம்',
    WEDDINGPLACEISREQUIRED: 'திருமண இடம் தேவை',
    INVALIDWEDDING: 'தவறான திருமண இடம்',
    INVALIDENGAGEMENT: 'தவறான நிச்சயதார்த்த இடம்',
    INVALIDSOLEMNIZED: 'தவறானது மூலம் புனிதப்படுத்தப்பட்டது',
    INVALIDGROOM: 'தவறான மணமகன் பெயர்',
    INVALIDGROOMPROFESSION: 'தவறான மணமகன் தொழில்',
    INVALIDGROOMCONDITION: 'தவறான மணமகன் நிலை',
    INVALIDGROOMADDRESS: 'தவறான மணமகன் முகவரி',
    INVALIDGROOMFATHER: 'தவறான மணமகன் தந்தை பெயர்',
    INVALIDGROOMMOTHER: 'தவறான மணமகன் தாய் பெயர்',
    INVALIDGROOMCONGREGATION: 'செல்லாத மாப்பிள்ளை தற்போதைய சபை',
    INVALIDGROOMPASTORATE: 'தவறான மணமகன் தற்போதைய மேய்ச்சல்',
    INVALIDGROOMDIOCESE: 'செல்லாத மணமகன் தற்போதைய மறைமாவட்டம்',
    INVALIDBRIDE: 'தவறான மணமகள் பெயர்',
    INVALIDBRIDEPROFESSION: 'தவறான மணமகள் தொழில்',
    INVALIDBRIDECONDITION: 'தவறான மணமகள் நிலை',
    INVALIDBRIDEADDRESS: 'தவறான மணமகள் முகவரி',
    INVALIDBRIDEFATHER: 'தவறான மணமகளின் தந்தை பெயர்',
    INVALIDMOTHER: 'தவறான மணமகளின் தாய் பெயர்',
    INVALIDBRIDECONGREGATION: 'தவறான மணமகள் தற்போதைய சபை',
    INVALIDBRIDEPASTORATE: 'தவறான மணமகள் தற்போதைய மேய்ச்சல்',
    INVALIDBRIDEDIOCESE: 'செல்லாத மணமகள் தற்போதைய மறைமாவட்டம்',
    INVALIDWITNESSONE: 'செல்லாத சாட்சி ஒருவர்',
    INVALIDWITNESSTWO: 'தவறான சாட்சி இரண்டு',
    INVALIDWITNESSTHREE: 'தவறான சாட்சி மூன்று',
    INVALIDWITNESSFOUR: 'தவறான சாட்சி நான்கு',
    ENGAGEMENTPLACE: 'நிச்சயதார்த்த இடம்',
    ENGAGEMENTPLACEISREQUIRED: 'நிச்சயதார்த்த இடம் தேவை',
    SOLEMNIZEDBY: 'புனிதப்படுத்தப்பட்டது மூலம்',
    WEDDINGTYPE: 'திருமண வகை',
    WEDDINGTYPEISREQUIRED: 'திருமண வகை தேவை',
    GROOMINFORMATION: 'மணமகன் தகவல்',
    GROOMNAME: 'மணமகன் பெயர்',
    GROOMNAMEISREQUIRED: 'மணமகன் பெயர் தேவை',
    GROOMBIRTHDATE: 'மணமகன் பிறந்த தேதி',
    GROOMBIRTHDATEISREQUIRED: 'மணமகன் பிறந்த தேதி தேவை',
    GROOMPROFESSION: 'மணமகன் தொழில்',
    GROOMPROFESSIONISREQUIRED: 'மணமகன் தொழில் தேவை',
    GROOMCONDITION: 'மணமகன் நிபந்தனை',
    GROOMCONDITIONISREQUIRED: 'மணமகன் நிபந்தனை தேவை',
    GROOMADDRESS: 'மணமகன் முகவரி',
    GROOMADDRESSISREQUIRED: 'மணமகன் முகவரி தேவை',
    GROOMFATHERNAME: 'மணமகன் தந்தை பெயர்',
    GROOMFATHERNAMEISREQUIRED: 'மணமகன் தந்தை பெயர் தேவை',
    GROOMMOTHERNAME: 'மணமகன் தாய் பெயர்',
    GROOMMOTHERNAMEISREQUIRED: 'மணமகன் தாய் பெயர் தேவை',
    ISGROOMBAPTISED: 'மணமகன் ஞானஸ்நானம் பெற்றாரா?',
    ISGROOMCONFIRMED: 'மணமகன் உறுதி செய்யப்பட்டாரா?',
    GROOMCURRENTCONGREGATION: 'மணமகன் தற்போதைய சபை',
    GROOMCURRENTCONGREGATIONISREQUIRED: 'மணமகன் தற்போதைய சபை தேவை',
    GROOMCURRENTPASTORATE: 'மணமகன் தற்போதைய மேய்ச்சல்',
    GROOMCURRENTPASTORATEISREQUIRED: 'மணமகன் தற்போதைய மேய்ச்சல் தேவை',
    GROOMCURRENTDIOCESE: 'மணமகன் தற்போதைய மறைமாவட்டம்',
    GROOMCURRENTDIOCESEISREQUIRED: 'மணமகன் தற்போதைய மறைமாவட்டம் தேவை',
    ISGROOMCHURCHMEMBER: 'மணமகன் சர்ச் உறுப்பினரா?',
    GROOMMEMBERID: 'மணமகன் உறுப்பினர் ஐடி',
    SELECTMEMBER: 'உறுப்பினரைத் தேர்ந்தெடுக்கவும்',
    BRIDEINFORMATION: 'மணமகள் தகவல்',
    BRIDENAME: 'மணமகள் பெயர்',
    BRIDENAMEISREQUIRED: 'மணமகளின் பெயர் தேவை',
    BRIDEBIRTHDATE: 'மணமகள் பிறந்த தேதி',
    BRIDEBIRTHDATEISREQUIRED: 'மணமகள் பிறந்த தேதி தேவை',
    BRIDEPROFESSION: 'மணமகள் தொழில்',
    BRIDEPROFESSIONISREQUIRED: 'மணமகள் தொழில் தேவை',
    BRIDECONDITION: 'மணமகள் நிபந்தனை',
    BRIDECONDITIONISREQUIRED: 'மணமகள் நிபந்தனை தேவை',
    BRIDEADDRESS: 'மணமகள் முகவரி',
    BRIDEADDRESSISREQUIRED: 'மணமகள் முகவரி தேவை',
    BRIDEFATHERNAME: 'மணமகளின் தந்தை பெயர்',
    BRIDEFATHERNAMEisrequired: 'மணமகளின் தந்தையின் பெயர் தேவை',
    BRIDEMOTHERNAME: 'மணமகளின் தாய் பெயர்',
    BRIDEMOTHERNAMEISREQUIRED: 'மணமகளின் தாய் பெயர் தேவை',
    ISBRIDEBAPTISED: 'மணமகள் ஞானஸ்நானம் பெற்றாரா?',
    ISBRIDECONFIRMED: 'மணமகள் உறுதி செய்யப்பட்டாரா?',
    BRIDECURRENTCONGREGATION: 'மணமகள் தற்போதைய சபை',
    BRIDECURRENTCONGREGATIONISREQUIRED: 'மணமகள் தற்போதைய சபை தேவை',
    BRIDECURRENTPASTORATE: 'மணமகள் தற்போதைய மேய்ச்சல்',
    BRIDECURRENTPASTORATEISREQUIRED: 'மணமகள் தற்போதைய மேய்ச்சல் தேவை',
    BRIDECURRENTDIOCESE: 'மணமகள் தற்போதைய மறைமாவட்டம்',
    BRIDECURRENTDIOCESEISREQUIRED: 'மணமகள் தற்போதைய மறைமாவட்டம் தேவை',
    ISBRIDECHURCHMEMBER: 'மணமகள் தேவாலய உறுப்பினரா?',
    BRIDEMEMBERID: 'மணமகள் உறுப்பினர் ஐடி',
    BRIDESELECTMEMBER: 'உறுப்பினரைத் தேர்ந்தெடுக்கவும்',
    OTHERINFORMATION: 'பிற தகவல்',
    FIRSTBANNSDATE: 'முதல் திருமண முன்னறிவிப்பு தேதி',
    FIRSTBANNSDATEISREQUIRED: 'முதல் திருமண முன்னறிவிப்பு தேதி தேவை',
    SECONDBANNSDATE: 'இரண்டாவது திருமண முன்னறிவிப்பு தேதி',
    SECONDBANNSDATEISREQUIRED: 'இரண்டாவது திருமண முன்னறிவிப்பு தேதி தேவை',
    THIRDBANNSDATE: 'மூன்றாவது திருமண முன்னறிவிப்பு தேதி',
    THIRDBANNSDATEISREQUIRED: 'மூன்றாவது திருமண முன்னறிவிப்பு தேதி தேவை',
    WITNESSONE: 'முதல் சாட்சி',
    WITNESSTWO: 'சாட்சி இரண்டு',
    WITNESSTHREE: 'சாட்சி மூன்று',
    WITNESSFOUR: 'சாட்சி நான்கு',
    INITIALDATERECEIVEDDATE: 'ஆரம்ப தேதி பெறப்பட்ட தேதி',
    INITIALDATERECEIVEDDATEISREQUIRED: 'ஆரம்ப தேதி பெறப்பட்ட தேதி தேவை',
    BEFOREBANNSCERTIFICATEDATE: 'சான்றிதழ் தேதி திருமண முன்னறிவிப்பு செய்வதற்கு முன்',
    AFTERBANNSCERTIFICATEDATE: 'சான்றிதழ் தேதி திருமண முன்னறிவிப்பு செய்வதற்கு பிறகு',
    WEDDINGEDITUPDATEHEADER: 'திருமணத்தைப் புதுப்பிக்கவும்',
    WEDDINGEDITADDHEADER: 'திருமணத்தைச் சேர்க்கவும்',
    WEDDINGEDITTOASTMESSAGEFORADD: 'திருமண விவரங்கள் வெற்றிகரமாக சேர்க்கப்பட்டது!',
    WEDDINGEDITTOASTMESSAGEFORUPDATE: 'திருமண விவரங்கள் வெற்றிகரமாக புதுப்பிக்கப்பட்டன!',
    // Wedding-List
    WEDDINGPARTICULAR: 'திருமணத்தின் சிறப்பு',
    BEFOREBANNS: 'திருமண முன்னறிவிப்பு முன்',
    AFTERBANNS: 'திருமண முன்னறிவிப்பு பிறகு',
    WEDDINGLISTHEADER: 'திருமணம்',
    WEDDINGLISTTOASTMESSAGE: 'உறுப்பினர் வெற்றிகரமாக நீக்கப்பட்டார்!',
    WEDDINGLISTWEDDINGDATE: 'திருமண தேதி',
    WEDDINGLISTWEDDINGPLACE: 'திருமண இடம்',
    // Wedding-Preview
    GROOMPROFESSIONS: 'மணமகன் தொழில்',
    GROOMCONDITIONS: 'மணமகன் நிபந்தனை',
    GROOMADDRESSS: 'மணமகன் முகவரி',
    ISGROOMBAPTISEDS: 'மணமகன் ஞானஸ்நானம் பெற்றாரா?',
    ISGROOMCONFIRMEDS: 'மணமகன் உறுதி செய்யப்பட்டாரா?',
    GROOMCURRENTCONGREGATIONS: 'மணமகன் தற்போதைய சபை',
    GROOMCURRENTPASTORATES: 'மணமகன் தற்போதைய மேய்ச்சல்',
    GROOMCURRENTDIOCESES: 'மணமகன் தற்போதைய மறைமாவட்டம்',
    ISGROOMCHURCHMEMBERS: 'மணமகன் சர்ச் உறுப்பினரா',
    GROOMCHURCHMEMBERID: 'மணமகன் சர்ச் உறுப்பினர் ஐடி',
    BRIDEPROFESSIONS: 'மணமகள் தொழில்',
    BRIDECONDITIONS: 'மணமகள் நிபந்தனை',
    BRIDEADDRESSS: 'மணமகள் முகவரி',
    ISBRIDEBAPTISEDS: 'மணமகள் ஞானஸ்நானம் பெற்றாரா?',
    ISBRIDECONFIRMEDS: 'மணமகள் உறுதி செய்யப்பட்டாரா?',
    BRIDECURRENTCONGREGATIONS: 'மணமகள் தற்போதைய சபை',
    BRIDECURRENTPASTORATES: 'மணமகள் தற்போதைய மேய்ச்சல்',
    BRIDECURRENTDIOCESES: 'மணமகள் தற்போதைய மறைமாவட்டம்',
    ISBRIDECHURCHMEMBERS: 'மணமகள் தேவாலய உறுப்பினரா',
    BRIDECHURCHMEMBERID: 'மணமகள் தேவாலய உறுப்பினர் ஐடி',
    WEDDINGPREVIEWHEADER: 'திருமண முன்னோட்டம்',
    // Burial
    BURIALTOASTMESSAGE: 'அடக்கம் செய்யப்பட்ட விவரங்கள் வெற்றிகரமாக நீக்கப்பட்டன!',
    BURIALGENDER: 'பாலினம்',
    CERTIFICATE: 'சான்றிதழ்',
    AGE: 'வயது',
    DEATHDATE: 'இறப்பு தேதி',
    BURIEDDATE: 'புதைக்கப்பட்ட தேதி',
    // Burial-Sidebar
    INVALIDPARENTS: 'தவறான பெற்றோர் பெயர்கள்',
    INVALIDBURIEDPLACE: 'செல்லாத புதைக்கப்பட்ட இடம்',
    INVALIDPRESBYTER: 'ப்ரெஸ்பைட்டரின் தவறான பெயர் புதைக்கப்பட்டது',
    NEWBURIALSIDEBARAGE: 'வயது',
    AGEISREQUIRED: 'வயது தேவை',
    PROFESSIONISREQUIRED: 'தொழில் தேவை',
    CAUSEOFDEATH: 'இறப்புக்கான காரணம்',
    CAUSEOFDEATHISREQUIRED: 'இறப்புக்கான காரணம் தேவை',
    NEWBURIALSIDEBARDEATHDATE: 'இறந்த தேதி',
    DEATHDATEISREQUIRED: 'இறந்த தேதி தேவை',
    NEWBURIALSIDEBARBURIEDDATE: 'புதைக்கப்பட்ட தேதி',
    BURIEDDATEISREQUIRED: 'புதைக்கப்பட்ட தேதி தேவை',
    BURIEDPLACE: 'புதைக்கப்பட்ட இடம்',
    BURIEDPLACEISREQUIRED: 'புதைக்கப்பட்ட இடம் தேவை',
    NAMEOFPRESBYTERBURIED: 'புதைக்கப்பட்ட பிரஸ்பைட்டரின் பெயர்',
    NAMEOFPRESBYTERBURIEDISREQUIRED: 'புதைக்கப்பட்ட பிரஸ்பைட்டரின் பெயர் தேவை',
    ISCHURCHMEMBER: 'சர்ச் உறுப்பினரா?',
    MEMBERID: 'உறுப்பினர் அடையாள எண்',
    ADDBURIALDETAILS: 'அடக்கம் விவரங்களைச் சேர்க்கவும்',
    UPDATEBURIALDETAILS: 'அடக்கம் விவரங்களைப் புதுப்பிக்கவும்',
    TOASTMESSAGEFORADDING: 'அடக்கம் விவரங்கள் வெற்றிகரமாக சேர்க்கப்பட்டது!',
    TOASTMESSAGEFORUPDATING: 'அடக்கம் விவரங்கள் வெற்றிகரமாக புதுப்பிக்கப்பட்டன!',
    // Master-Ledger
    GROUP: 'குழு',
    ICON: 'உருவம்',
    ORDERNO: 'உத்தரவு எண்',
    LEDGERHEADER: 'பேரேடுகள்',
    LEDGERTOASTMESSAGEFORUPDATE: 'பேரேடு வெற்றிகரமாக புதுப்பிக்கப்பட்டது!',
    LEDGERTOASTMESSAGEFORADD: 'பேரேடு வெற்றிகரமாக சேர்க்கப்பட்டது!',
    TOSTMESSAGEHEAD: 'வெற்றி!',
    LEDGERTOASTMESSAGEFORDELETE: 'லெட்ஜர் வெற்றிகரமாக நீக்கப்பட்டது!',
    UPDATELEDGER: 'லெட்ஜரைப் புதுப்பிக்கவும்',
    ADDLEDGER: 'லெட்ஜரைச் சேர்க்கவும்',
    // Auth-Login
    WELCOME: 'சர்ச்பெல்லுக்கு வரவேற்கிறோம்!',
    SIGNIN: 'உங்கள் கணக்கில் உள்நுழையவும்.',
    MOBILENUMBER: 'கைபேசி எண்',
    MOBILEREQUIRED: 'கைபேசி எண் தேவை',
    OTP: 'OTP குறியீடு',
    OTPREQUIRED: 'OTP குறியீடு தேவை',
    VERIFY: 'OTP ஐ சரிபார்க்கவும்',
    SEND: 'OTP அனுப்பவும்',
    CONTACTSUPPORT: 'எங்கள் மேடையில் புதியதா? ஆதரவைத் தொடர்பு கொள்ளுங்கள்!',
    POINTSREQUIREDISREQUIRED: 'தேவையான புள்ளிகள் தேவை',
    INVALIDPOINTSREQUIRED: 'தவறான புள்ளிகள் தேவை',
    // Footer
    RIGHTSRESERVED: ', அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை',
    COPYRIGHT: 'காப்புரிமை',
    // Navbar
    USERACTIVITY: 'பயனர் செயல்பாடு',
    SETTINGS: 'அமைப்புகள்',
    LOGOUT: 'வெளியேறு',
    // User-Activity
    ACTIVITYDATE: 'செயல் தேதி',
    CRITICALITY: 'விமர்சனம்',
    MODULE: 'தொகுதி',
    ACTION: 'நடவடிக்கை',
    ACTIVITYBY: 'செயல்பாடு மூலம்',
    // Account-Settings
    GENERAL: 'பொது',
    CODE: 'குறியீடு',
    EMAILS: 'மின்னஞ்சல்',
    DIOCESE: 'மறைமாவட்டம்',
    NAMEFORMAT: 'பெயர் வடிவம்',
    DATEFORMAT: 'தேதி வடிவம்',
    LOGOURL: 'சின்னம் URL',
    MONTHLYDEFAULTER: 'மாதாந்திர தவறியவர்',
    DECLARATIONNEEDED: 'பிரகடனம் தேவை',
    // LOGOUT
    WANTTOLOGOUT: 'நிச்சயமாக வெளியேற விரும்புகிறீர்களா?',
    REVERTTHIS: 'உங்களால் இதைத் திரும்பப் பெற முடியாது!',
    YESLOGOUT: 'ஆம், வெளியேறு!',
    // SIGNATURE FIELD
    SIGNATURE: 'கையெழுத்து',
    SIGNATURENEEDED: 'கையொப்பம் தேவை',
    ACCOUNTSS: 'கணக்குகள்',
    PRESBYTER: 'பிரஸ்பைட்டர்',
    CANCELSIGNATURE: 'ரத்து செய்',
    // DIOCESE ACCESS
    DIOCESEACCESS: 'மறைமாவட்ட அணுகல்',
    LEDGER: 'பேரேடு',
    CANCELDIOCESEACCESS: 'ரத்து செய்',
    HEADERS: 'தேவாலய அமைப்புகள்',
    // Auth-Service
    WELCOMEMSG: '👋 வரவேற்கிறோம், ',
    LOGGEDIN: 'நீங்கள் வெற்றிகரமாக உள்நுழைந்துள்ளீர்கள் ',
    EXPLORE: ' சர்ச்பெல்லின் பயனர். இப்போது நீங்கள் ஆராய ஆரம்பிக்கலாம். மகிழுங்கள்! 🎉',
    NOTAVAILABLE: 'எதுவும் கிடைக்கவில்லை',
    LATITUDE: 'Latitude',
    LONGITUDE: 'Longitude',
    LATITUDEISREQUIRED: 'Latitude is required',
    LONGITUDEISREQUIRED: 'Longitude is required',
    INVALIDLATITUDE: 'Latitude must be between -90 and 90',
    INVALIDLONGITUDE: 'Longitude must be between -180 and 180',
    IMPORTBRANCHESFROMEXCEL: 'Import Branches from Excel',
    VALIDBRANCHES: 'Valid Branches',
    DOWNLOADTEMPLATE: 'Download Template',
    BRANCHESIMPORTSUCCESS: 'Branches imported successfully',
    DELIVERYMETHODS: 'Delivery Methods',
    INFONOTE: 'Info Note',
    INVALIDINFONOTE: 'Invalid info note',
    // AI USAGE MONITORING (English fallback text)
    AIUSAGETRACKINGENABLED: 'Enable AI Usage Tracking',
    AIUSAGETRACKINGHINT: 'Enable storing AI token usage and cost information for monitoring and optimisation. Mainly used for debugging; can be turned on in production to monitor AI cost. Adds one small record per AI call while enabled.',
    AIUSAGE_MENU: 'AI Usage Monitoring',
    AIUSAGE_TITLE: 'AI Usage Monitoring',
    AIUSAGE_TRACKING: 'Tracking',
    AIUSAGE_ON: 'ON',
    AIUSAGE_OFF: 'OFF',
    AIUSAGE_ALL: 'All',
    AIUSAGE_TYPE: 'Type',
    AIUSAGE_TYPE_RECEIPT: 'Receipt',
    AIUSAGE_TYPE_CATEGORY: 'Category',
    AIUSAGE_MODEL: 'Model',
    AIUSAGE_SEARCH_RECEIPT: 'Search by Receipt ID',
    AIUSAGE_DATE_FROM: 'Date From',
    AIUSAGE_DATE_TO: 'Date To',
    AIUSAGE_CLEAR: 'Clear',
    AIUSAGE_TOTAL_REQUESTS: 'Total AI Requests',
    AIUSAGE_TOTAL_COST: 'Total Cost (USD)',
    AIUSAGE_TOTAL_INPUT: 'Total Input Tokens',
    AIUSAGE_TOTAL_OUTPUT: 'Total Output Tokens',
    AIUSAGE_TOTAL_CACHED: 'Total Cached Tokens',
    AIUSAGE_AVG_TIME: 'Avg Processing Time',
    AIUSAGE_COL_ID: 'ID',
    AIUSAGE_COL_RECEIPT: 'Receipt ID',
    AIUSAGE_COL_TYPE: 'Type',
    AIUSAGE_COL_MODEL: 'Model',
    AIUSAGE_COL_INPUT: 'Input Tokens',
    AIUSAGE_COL_CACHED: 'Cached Tokens',
    AIUSAGE_COL_OUTPUT: 'Output Tokens',
    AIUSAGE_COL_COST: 'Cost USD',
    AIUSAGE_COL_TIME: 'Processing Time',
    AIUSAGE_COL_CREATED: 'Created Date',
    // QR CODES
    QRCODES: 'QR Codes',
    QR_TOTAL_STORES: 'Total Stores',
    QR_GENERATED_COUNT: 'QR Generated',
    QR_TOTAL_SCANS: 'Total Scans',
    QR_STORE: 'Store',
    QR_CONTACT: 'Contact Person',
    QR_PHONE: 'Phone',
    QR_STATUS: 'Status',
    QR_STATUS_GENERATED: 'Generated',
    QR_STATUS_NOT_GENERATED: 'Not Generated',
    QR_GENERATE: 'Generate',
    QR_GENERATE_ALL: 'Generate All',
    QR_GENERATE_ALL_CONFIRM: 'This will generate QR codes for all stores that do not have one yet.',
    QR_GENERATED: 'QR code generated',
    QR_PREVIEW: 'Preview',
    QR_DOWNLOAD_PNG: 'Download PNG',
    QR_DOWNLOAD_SVG: 'Download SVG',
    QR_COPY_URL: 'Copy URL',
    QR_URL_COPIED: 'QR URL copied',
    QR_COPY_FAILED: 'Failed to copy URL',
    QR_REGENERATE: 'Regenerate',
    QR_REGENERATE_CONFIRM: 'Regenerating will invalidate the current QR code. Continue?',
    QR_REGENERATED: 'QR code regenerated',
    QR_REGENERATE_FAILED: 'Failed to regenerate QR code',
    QR_DOWNLOAD_FAILED: 'Failed to download QR code',
    QR_PREVIEW_FAILED: 'Failed to load QR preview',
    QR_NO_PREVIEW: 'No preview available',
    QR_LAST_SCANNED: 'Last Scanned',
    QR_BY_PLATFORM: 'Scans by Platform',
    QR_BY_DEVICE: 'Scans by Device',
    QR_LAST_7_DAYS: 'Last 7 Days',
    QR_NO_SCANS: 'No scans yet',
  },
};
